<template>
  <div>
    <div class="modal fade" id="on-boarding-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <!-- purchasing-container--v2 opts the modal into the redesigned
             purchases stylesheet so inputs, buttons, dividers, alerts and the
             surface palette match the rest of the post-payment / pricing UI. -->
        <div class="modal-content purchasing-container--v2">
          <button type="button" class="close btn-link" data-bs-dismiss="modal" :aria-label="$t('shared.close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body">
            <div class="row p-0 m-0 min-height-80">
              <div
                class="left-col p-2 col-12 col-md-6 d-flex align-items-center justify-content-center"
                :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
              >
                <div class="image-gradient d-block d-md-none"></div>
                <div class="content-container">
                  <OnBoardingDetailPage />
                </div>
              </div>
              <!-- Right-hand auth column. Subtle topographic motif scaffolds
                   the dark surface so it doesn't read as a flat black panel.
                   Imagery on the LEFT pane is unchanged per spec. -->
              <div class="right-col p-2 col-12 col-md-6 d-flex align-items-center justify-content-center">
                <div class="topo-motif" aria-hidden="true"></div>
                <div class="content-container">
                  <OnBoardingPageRouter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { OnBoardingGoalUtility } from '../../utils/models/OnBoardingGoal';
import OnBoardingDetailPage from './components/OnBoardingDetailPage.vue';
import OnBoardingPageRouter from './components/OnBoardingPageRouter.vue';

export default defineComponent({
  components: {
    OnBoardingDetailPage,
    OnBoardingPageRouter,
  },
  computed: {
    onBoardingGoalUtility() {
      return new OnBoardingGoalUtility(this.$store.state.onBoarding.onBoardingGoal);
    },
    topPage() {
      return this.$store.getters['onBoarding/lastPage'];
    },
    backgroundImage() {
      return this.onBoardingGoalUtility.image(this.topPage);
    },
  },
});
</script>

<style scoped>

.min-height-80{
  min-height: 80vh;
}

.modal{
  overflow: scroll;
}
.modal-dialog {
  width: 92%;
  max-width: none;
  margin: auto;
}

.modal-content {
  height: auto;
  min-height: 80vh;
  border-radius: 0;
}

.modal-body{
  padding: 0;
}

.image-gradient{
  background: rgb(32,32,32);
  background: linear-gradient(0deg, rgba(32,32,32,1) 0%, rgba(32,32,32,0) 100%);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.left-col{
  background-repeat: no-repeat;
  background-position: center left;
  background-size: cover;
}

/* Right-hand panel — kept dark per the brand, but with a subtle topographic
   contour motif so the surface has texture instead of feeling like a blank
   void. Stays well behind the form content (low opacity). */
.right-col {
  position: relative;
  overflow: hidden;
}
.topo-motif {
  position: absolute;
  inset: 0;
  background-image: url('../../images/map-lines.webp');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 140% auto;
  opacity: 0.06;
  pointer-events: none;
  z-index: 0;
}

.close{
  position: absolute;
  top: 10px;
  right: 18px;
  z-index: 100;
  font-size: 4em;
  width: 50px;
  height: 50px;
}

.content-container{
  width: 60%;
  z-index: 1;
}

/* The legacy `/deep/ .form-control` flat-bottom-only rule was removed —
   purchases-v2 (`.pro-field__input`) now provides the rounded, padded input
   treatment for everything inside `.purchasing-container--v2`. */

@media (min-width: 2000px) {
  .left-col{
    background-repeat: no-repeat;
    background-position: center left;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
}

@media (max-width: 1200px) {
  .content-container{
    width: 80%;
  }

  .left-col{
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
}

@media (max-width: 769px) {
  .left-col{
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% auto;
    padding: 6em 2em 0 !important;
  }

  .right-col{
    padding: 2em 2em 6em !important;
  }

  .close{
    top: .2em;
    right: .2em;
  }
}

@media (max-width: 420px) {
  .content-container{
    width: 100%;
  }

  .left-col {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

}

</style>
